import { gql, useApolloClient } from '@apollo/client'
import { Logger } from '@wolfdanepug/common-react'
import { createContext, useState } from 'react'
import { GetUnstableData, SetUnstableData } from '../../graphql/docs'

export const DataContext = createContext<any>({
	fetchData: () => {},
	saveData: () => {},
	useUnstableData: () => ({})
})

export const DataProvider = ({ children }: any) => {
	const [unstableData, setUnstableData] = useState<any>(null)

	const apollo = useApolloClient()

	const fetchData = async () => {
		const { data } = await apollo.query({
			query: gql(GetUnstableData),
			variables: { context: 'onboarding' },
			fetchPolicy: 'cache-first'
		})
		setUnstableData(data.getUnstableData)
	}

	/**
	 * Save Onboarding Data
	 * @param {any} onboardingData
	 * @returns {Promise<any>}
	 */
	const saveData = async (onboardingData: any): Promise<any> => {
		try {
			Logger.log('[OnboardingProvider] saveData', onboardingData)
			const requestData = { ...(onboardingData.data || onboardingData) }
			onboardingData.id && (requestData.id = onboardingData.id)

			const { data } = await apollo.mutate({
				mutation: gql(SetUnstableData),
				variables: { input: { context: 'onboarding', data: requestData } }
			})
			return { data: data.setUnstableData.data }
		} catch (e) {
			Logger.error('[OnboardingProvider] saveData error', e)
		}
	}

	const useUnstableData = () => {
		return unstableData
	}

	return (
		<DataContext.Provider
			value={{
				fetchData,
				saveData,
				useUnstableData
			}}
		>
			{children}
		</DataContext.Provider>
	)
}
